exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aboutCOPImageCard {\r\n  margin-left: 40px;\r\n  margin-right: 40px;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.aboutCOPImage {\r\n  height: 330px;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.Paraalign {\r\n  margin-left: 45px;\r\n}\r\n@media screen and (max-width: 425px) {\r\n  .Paraalign {\r\n    margin-left: 5px !important;\r\n  }\r\n}\r\n", ""]);

// exports
